const initialState = {
  selectCalendar: '',
  yearMonthFlag: false,
  isDashboardCalendar: false,
};

export default initialState;
